import { InputField } from 'components/Global';
import SelectFieldDropdown from 'components/Global/SelectFieldDropdown';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { checkEmptyObject } from 'utils/functionality';
import SelectFieldTime from 'components/Global/SelectFieldTime';
import TableOperationalSetting from '../TableOperationalSetting';

const NewAdditionalGarageSetting = ({
  serviceData,
  locationId,
  data,
  setData,
  handleKeyDown,
  numberInputOnWheelPreventChange,
  index,
  operationalSetting,
  setOperationalSetting,
}) => {
  const [mappedCategories, setMappedCategories] = useState([]);

  const mode = location.pathname?.split('/')[2];

  const { data: allCategories } = useSelector((state) => state.category);

  useEffect(() => {
    if (checkEmptyObject(allCategories)) return;
    if (allCategories.category?.length > 0) {
      setMappedCategories(allCategories.category.map((item) => ({ ...item, value: item.name.toLowerCase() })));
    }
  }, [allCategories, locationId]);

  const handleTipeSewa = (e) => {
    const getServiceData = serviceData?.find((type) => type.id == +e.target.id);

    setData((prev) =>
      prev.map((item, idx) =>
        idx === index
          ? {
              ...prev[index],
              service: +e.target.id,
              value: getServiceData?.value,
            }
          : item,
      ),
    );
  };

  const handleValueInput = (e) => {
    setData((prev) =>
      prev.map((item, idx) => (idx === index ? { ...prev[index], outside_operational_fee: e.target.value } : item)),
    );
  };

  const handlePenaltiStatus = () => {
    setData((prev) =>
      prev.map((item, idx) =>
        idx === index ? { ...prev[index], outside_operational_status: !prev[index].outside_operational_status } : item,
      ),
    );
  };

  return (
    <div className="garage-detail__additional-setting__card">
      <div className="garage-detail__additional-setting__form">
        <SelectFieldDropdown
          label="Tipe Sewa"
          htmlFor="rent-type-additional"
          data={serviceData}
          placeholder="Pilih Tipe Sewa"
          value={data?.service}
          onChange={handleTipeSewa}
          disable={!locationId}
        />

        <div className="garage-detail__operational-status">
          <p>Penalti Status</p>

          <div className="garage-detail__status-info">
            <div className="user__toggle-status">
              <label className="switch">
                <input
                  type="checkbox"
                  onChange={handlePenaltiStatus}
                  role={'switch'}
                  checked={data?.outside_operational_status}
                />
                <span className="slider"></span>
              </label>
            </div>

            {data?.outside_operational_status ? (
              <span className="user__status-badge user__status-badge--active">Aktif</span>
            ) : (
              <span className="user__status-badge user__status-badge--blocked">Inactive</span>
            )}
          </div>
        </div>

        <InputField
          label="Tarif Penalti"
          type="number"
          placeholder="Masukkan Jumlah Tarif Penalti"
          value={data?.outside_operational_fee ?? ''}
          onChange={handleValueInput}
          onWheel={numberInputOnWheelPreventChange}
          onKeyDown={handleKeyDown}
        />

        <div className="garage-detail__time">
          <SelectFieldTime
            label="Jam Buka"
            htmlFor="jam-buka"
            placeholder="00:00"
            value={data.start_time}
            onChange={(hour, minute) => {
              setData((prev) =>
                prev.map((item, idx) =>
                  idx == index ? { ...item, start_time: `${hour || '00'}:${minute || '00'}` } : item,
                ),
              );
            }}
            icon={false}
            showAllHours={true}
          />
          <SelectFieldTime
            label="Jam Tutup"
            htmlFor="jam-tutup"
            placeholder="00:00"
            value={data.end_time}
            onChange={(hour, minute) => {
              setData((prev) =>
                prev.map((item, idx) =>
                  idx == index ? { ...item, end_time: `${hour || '00'}:${minute || '00'}` } : item,
                ),
              );
            }}
            disable={data.start_time === ''}
            icon={false}
            showAllHours={true}
          />
        </div>
      </div>

      <TableOperationalSetting
        locationId={locationId}
        data={operationalSetting}
        setData={setOperationalSetting}
        mode={mode}
        categoryData={mappedCategories}
        numberInputOnWheelPreventChange={numberInputOnWheelPreventChange}
        handleKeyDown={handleKeyDown}
        selectedService={data}
      />
    </div>
  );
};

export default NewAdditionalGarageSetting;
